import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_PLACE_PREDICTIONS } from '../../queries/get-place-predictions.js';
import '../../queries/get-place-details.js';
import fromQueryPlacePredictionsToPlacePredictions from './adapters/fromQueryPlacePredictionsToPlacePredictions.js';

const usePlacePredictions = (options)=>{
    var ref1;
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_PLACE_PREDICTIONS, swcHelpers.objectSpread({}, options, {
        context: swcHelpers.objectSpread({}, options === null || options === void 0 ? void 0 : options.context, {
            forwardHeaders: swcHelpers.objectSpread({}, options === null || options === void 0 ? void 0 : (ref1 = options.context) === null || ref1 === void 0 ? void 0 : ref1.forwardHeaders, {
                'Accept-Language': locale
            })
        })
    }));
    const data = React.useMemo(()=>{
        var ref;
        return fromQueryPlacePredictionsToPlacePredictions((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placePredictions);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { usePlacePredictions as default };
//# sourceMappingURL=use-place-predictions.js.map
